/******************************************************************************
 *** BgtOvrlExpndViewDialog ** 총괄조합비 * 지출결의서 상세정보 모달
*******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import { budgetFilesProps } from "@/js/common/types/types";
import Util from "@/js/common/Util";
import React from "react";
import BudgetViewFile from "../../budgetFileBox/BudgetViewFile";
import Button from "@/js/common/ui/Button";
import DatePickerBox from "@/js/common/ui/input/DatePickerBox";
import SelectBox from "@/js/common/ui/input/SelectBox";
import NumberTextBox from "@/js/common/ui/input/NumberTextBox";
import TextBox from "@/js/common/ui/input/TextBox";
import Modal from "@/js/common/ui/modal/Modal";
import BgtOvrlGrnamtViewDialog from "./BgtOvrlGrnamtViewDialog";
import BgtOvrlEmpGrnamtViewDialog from "./BgtOvrlEmpGrnamtViewDialog";
import DialogTitleBar from "@/js/system/common/DialogTitleBar";
import AtrzLineBox from "./AtrzLineBox";

interface Props {
    ovrlMbsdsExpndDocId: string;
    setOvrlExpndModalOpen: Function;
}
const BgtOvrlExpndViewDialog = ( {ovrlMbsdsExpndDocId, setOvrlExpndModalOpen}: Props ) => {
    const [expndRsdocNo      , setExpndRsdocNo      ] = React.useState<string>(""); // 결의서 문서번호
    const [orgCd             , setOrgCd             ] = React.useState<string>(""); // 조직코드
    const [grnamtSeCd        , setGrnamtSeCd        ] = React.useState<string>(""); // 교부금 구분 코드
    const [implDt            , setImplDt            ] = React.useState<string>(""); // 행위년월일(집행일자)(YYYYMMDD)
    const [bgtSbjct1stCd     , setBgtSbjct1stCd     ] = React.useState<string>(""); // 1차 코드(관)
    const [bgtSbjct2stCd     , setBgtSbjct2stCd     ] = React.useState<string>(""); // 2차 코드(항)
    const [bgtSbjct3stCd     , setBgtSbjct3stCd     ] = React.useState<string>(""); // 3차 코드(목)
    const [abstrCn           , setAbstrCn           ] = React.useState<string>(""); // 적요
    const [memo              , setMemo              ] = React.useState<string>(""); // 메모
    const [implAmt           , setImplAmt           ] = React.useState<string>(""); // 집행금액
    const [atrzSttsCd        , setAtrzSttsCd        ] = React.useState<string>("00"); // 결재상태정보(전체[00])
    const [atrzOpnnCn        , setAtrzOpnnCn        ] = React.useState<string>(""); // 반려사유(결재의견)
    const [listLine, setListLine] = React.useState<any[]>([]);  // 결재 라인 정보
    const [openLine, setOpenLine] = React.useState<boolean>(false); // 기본 펼침/접힘

    const [savedExpndFiles, setSavedExpndFiles] = React.useState<budgetFilesProps[]>([]); // 저장된 파일

    const [grnamtModalOpen   , setGrnamtModalOpen   ] = React.useState<boolean>(false); // 교부금
    const [empGrnamtModalOpen, setEmpGrnamtModalOpen] = React.useState<boolean>(false); // 우정실무원 교부금

    const [grnamtSum   , setGrnamtSum   ] = React.useState<string>(""); // 교부금 합계
    const [empGrnamtSum, setEmpGrnamtSum] = React.useState<string>(""); // 우정실무원 교부금 합계
    const [sumTotal    , setSumTotal    ] = React.useState<string>(""); // 교부금 전체(교부금 + 우정실무원) 합계

    // TD 클릭
    const [hoveredCell, setHoveredCell] = React.useState<string | null>(null);

    // 특별회계기금 지출결의서 상세정보 조회
    React.useEffect(() => {
        AppContext.showSpinner();
        Axios.dataAccess({
            url: "system/bgt/ovrl/whol/select-ovrl-whol-expnd-dtl.do",
            methodType: "post",
            paramType: "json",
            paramData: {
                ovrlMbsdsExpndDocId: ovrlMbsdsExpndDocId   // 지출결의서 문서 ID
            },
            onSuccessFn: (res: any) => {
                if (Util.isNotEmpty(res.result.item)) {
                    setExpndRsdocNo (res.result.item.expndRsdocNo ); // 결의서 문서번호
                    setOrgCd        (res.result.item.orgCd        ); // 조직
                    setGrnamtSeCd   (res.result.item.grnamtSeCd   ); // 교부금 구분코드
                    setImplDt       (res.result.item.implDt       ); // 행위년월일(집행일자)
                    setBgtSbjct1stCd(res.result.item.bgtSbjct1stCd); // 1차 코드(관)
                    setBgtSbjct2stCd(res.result.item.bgtSbjct2stCd); // 2차 코드(항)
                    setBgtSbjct3stCd(res.result.item.bgtSbjct3stCd); // 3차 코드(목)
                    setAbstrCn      (res.result.item.abstrCn      ); // 적요
                    setMemo         (res.result.item.memo         ); // 메모
                    setImplAmt      (res.result.item.implAmt      ); // 집행금액
                    setAtrzSttsCd   (res.result.item.atrzSttsCd   ); // 결재상태정보
                    setAtrzOpnnCn   (res.result.item.atrzOpnnCn   ); // 반려사유(결재의견)
                    setListLine(res.result.listLine || []);

                    setGrnamtSum   (res.result.listGrnamtSum.sumDtbnAmt); // 교부금 합계
                    setEmpGrnamtSum(res.result.listEmpGrnamtSum.dtbnAmt); // 우정실무원 교부금 합계
                    setSumTotal(res.result.listGrnamtSum.sumDtbnAmt + res.result.listEmpGrnamtSum.dtbnAmt); // 교부금 전체  합계

                    setSavedExpndFiles(res.result.listFile); // 첨부파일
                }
                AppContext.hideSpinner();
            },
        });
    }, [ovrlMbsdsExpndDocId]);

    return (
        <div className="w100p dpFlx jcC">
            <div className="dpFlx gap14 aiFs">
                <div className="w480 pt10">
                    {/* 지출결의서 상세내용 */}
                    <div className="bd1d9d9d9 bdrd6 bgcWhite p15">
                        <div className="mb10 dpFlx jcSb">
                            <div>
                                <span className="fm-b fs16 fc007bff ls1 fw700">지출결의서 상세내용</span>
                                <span className="fm-b fs13 ls06 fc616EEA ml10">[{Util.getValToCode("ATRZ_STTS_CD", atrzSttsCd)}]</span>
                            </div>
                            <div>
                                <span className="fm-b fs13 ls06 fc777777 mr10">{expndRsdocNo}</span>
                            </div>
                        </div>

                        {["03", "04", "05"].includes(atrzSttsCd) && (
                        <AtrzLineBox
                            listLine={listLine}
                            open={openLine}
                            onToggle={() => setOpenLine((v) => !v)}
                        />
                        )}

                        {/* 행위년월일, 금액 */}
                        <div className="dpFlx gap10 aiE mb10">
                            {/* 금액 */}
                            <div className="flx1">
                                <div className="h30 dpFlx aiE pb5">
                                    <span className="fm-b fs13 ls06 fc111111">행위년월일</span>
                                </div>
                                <DatePickerBox value={implDt}
                                    width={210} height={36} fontSize={14}
                                    fontFamily="fm-c" color="#333" letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                    bgColor={"#F6F6F6"}
                                    textAlign="left"
                                    calendarThemeColor={AppContext.themeColor}
                                    disabled={true}
                                    onChange={(data: string) => setImplDt(data)}
                                />
                            </div>

                            {/* 집행 가능 금액 */}
                            <div className="flx1">
                                <div className="h30 dpFlx aiE pb5">
                                    <span className="fm-b fs13 ls06 fc111111">금액 (원)</span>
                                </div>
                                <div className="w210 h36 dpFlx aiC bsBdb">
                                    <NumberTextBox value={implAmt}
                                        className="bgcFFE6CE w100p h36 bd1 bdrd2"
                                        thousandsGroupStyle="thousand" thousandSeparator=","
                                        placeholder="0"
                                        fontSize={14} fontFamily="fm-c" letterSpacing={-1}
                                        onChange={(data: string) => setImplAmt(data)}
                                        inputClass={"taR mr10"}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* 관/항/목 */}
                        <div className="dpFlx mb10">
                            {/* 관 */}
                            <div className="dpFlx flxdCol flx1">
                                <div className="h30 dpFlx aiE pb5">
                                    <span className="fm-b fs13 ls06 fc111111">관</span>
                                </div>
                                <SelectBox value={bgtSbjct1stCd}
                                    width={140} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                    background="#F6F6F6" paddingRight={8}
                                    codeArray={[{ code: "", name: "선택" }].concat(Util.getBgt1CodeArray("02", orgCd))}
                                    placeholder="선택"
                                    onChangeFunc={(data: string) => setBgtSbjct1stCd(data)}
                                    disabled={true}
                                />
                            </div>

                            {/* 항 */}
                            <div className="dpFlx flxdCol flx1">
                                <div className="h30 dpFlx aiE pb5">
                                    <span className="fm-b fs13 ls06 fc111111">항</span>
                                </div>
                                <SelectBox value={bgtSbjct2stCd}
                                    width={140} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                    background="#F6F6F6" paddingRight={8}
                                    codeArray={[{ code: "", name: "선택" }].concat(Util.getBgt2CodeArray(bgtSbjct1stCd, orgCd))}
                                    placeholder="선택"
                                    onChangeFunc={(data: string) => setBgtSbjct2stCd(data)}
                                    disabled={true}
                                />
                            </div>

                            {/* 목 */}
                            <div className="dpFlx flxdCol flx1">
                                <div className="h30 dpFlx aiE pb5">
                                    <span className="fm-b fs13 ls06 fc111111">목</span>
                                </div>
                                <SelectBox  value={bgtSbjct3stCd}
                                    width={140} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                    background="#F6F6F6" paddingRight={8}
                                    codeArray={[{ code: "", name: "선택" }].concat(Util.getBgt3CodeArray(bgtSbjct2stCd, orgCd))}
                                    placeholder="선택"
                                    onChangeFunc={(data: string) => setBgtSbjct3stCd(data)}
                                    disabled={true}
                                />
                            </div>
                        </div>

                        {/* 적요 */}
                        <div className="dpFlx flxdCol mb10">
                            <div className="h30 dpFlx aiE pb5">
                                <span className="fm-b fs13 ls06 fc111111">적요</span>
                            </div>
                            <TextBox value={abstrCn}
                                width={454} height={36} fontSize={14}
                                fontFamily="fm-c" color="#333" letterSpacing={-1}
                                borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                style={{ backgroundColor: "#F6F6F6", padding: "0 12px" }}
                                onChangeFunc={(text: string) => setAbstrCn(text)}
                                mode={"disabled"}
                            />
                        </div>

                        {/* 메모 */}
                        <div className="dpFlx flxdCol mb5">
                            <div className="h30 dpFlx aiE pb5">
                                <span className="fm-b fs13 ls06 fc111111">메모</span>
                            </div>
                            <TextBox value={memo}
                                width={454} height={36} fontSize={14}
                                fontFamily="fm-c" color="#333" letterSpacing={-1}
                                borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                style={{ backgroundColor: "#F6F6F6", padding: "0 12px" }}
                                onChangeFunc={(text: string) => setMemo(text)}
                                mode={"disabled"}
                            />
                        </div>

                        {/* 첨부파일 */}
                        <BudgetViewFile
                            fileSeCd         = "C02" // 파일구분코드(총괄교부금_지출결의서[B02])
                            savedBudgetFiles = {savedExpndFiles}
                            width = "450px"
                            height = "70px"
                        />

                        {/* 반려 */}
                        {atrzSttsCd === "05" &&
                            <div className="dpFlx flxdCol mb5">
                                <div className="h30 dpFlx aiE pb5">
                                    <span className="fm-b fs13 ls06 fc111111">반려</span>
                                </div>
                                <div className="dpFlx aiFs">
                                    <div className="flxg1 bsBdb">
                                        <textarea
                                            value={atrzOpnnCn}
                                            className="h70 bsBdb p10 bd1 bdcDFDFDF bdrd2 fm-c fs14 fc333333 ls1 bgcWhite rszN"
                                            style={{width: "454px"}}
                                            maxLength={2000}
                                            onChange={(e) => setAtrzOpnnCn(e.target.value)}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        }


                        <div className="h30 dpFlx jcSb aiE pb5 mt10">
                            <span className="fm-b fs13 ls06 fc111111 mb5">조합비 지출 내역</span>

                        </div>
                        <div className="w100p ofxA">
                            <div style={{ minWidth: 320 }}>
                                <div className="">
                                    <table style={{borderCollapse: "collapse", width: "100%"}}>
                                        <colgroup>
                                            <col className="w100"></col>
                                            <col className="w120"></col>
                                            <col className="w100"></col>
                                        </colgroup>
                                        <thead>
                                            <tr className="bgcf0f8ff h30">
                                                <th className="fm-a fs12 fc555555" style={{border: "1px solid #ddd"}}>교부금</th>
                                                <th className="fm-a fs12 fc555555" style={{border: "1px solid #ddd"}}>우정실무원교부금</th>
                                                <th className="fm-a fs12 fc555555" style={{border: "1px solid #ddd"}}>합계</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                {grnamtSeCd === "01" ?
                                                    <td className="h28 taC fm-c fs12 fc2B2B2B"
                                                        style={{
                                                                border: "1px solid #ddd",
                                                                cursor: "pointer",
                                                                backgroundColor: hoveredCell === "A" ? "#C0E6F4" : "transparent",
                                                                transition: "background-color 0.2s ease",
                                                            }}
                                                            onMouseEnter={() => setHoveredCell("A")}
                                                            onMouseLeave={() => setHoveredCell(null)}
                                                            onClick={() => {
                                                                setGrnamtModalOpen(true);
                                                            }}>
                                                            {Util.comma(grnamtSum)}
                                                    </td>
                                                :
                                                    <td className="h28 taC fm-c fs12 fcBDBDBD" style={{border: "1px solid #ddd", backgroundColor: "#F6F6F6"}}>0</td>
                                                }
                                                {grnamtSeCd === "02" ?
                                                    <td className="h28 taC fm-c fs12 fc2B2B2B"
                                                        style={{
                                                                border: "1px solid #ddd",
                                                                cursor: "pointer",
                                                                backgroundColor: hoveredCell === "B" ? "#C0E6F4" : "transparent",
                                                                transition: "background-color 0.2s ease",
                                                            }}
                                                            onMouseEnter={() => setHoveredCell("B")}
                                                            onMouseLeave={() => setHoveredCell(null)}
                                                            onClick={() => setEmpGrnamtModalOpen(true)}>
                                                            {Util.comma(empGrnamtSum)}
                                                    </td>
                                                :
                                                    <td className="h28 taC fm-c fs12 fcBDBDBD" style={{border: "1px solid #ddd", backgroundColor: "#F6F6F6"}}>0</td>
                                                }
                                                <td className="h28 taC fm-c fs12 fc2B2B2B taR pr5" style={{border: "1px solid #ddd"}}>{Util.comma(sumTotal)}</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ========================= 교부금 모달 ========================= */}
                    <Modal modalOpen={grnamtModalOpen} dim={true} visible={true}
                        titleEl={<DialogTitleBar title="교부금 배정 관리" />}
                        onCloseFunc={() => setGrnamtModalOpen(false)}
                    >
                        <BgtOvrlGrnamtViewDialog
                            ovrlMbsdsExpndDocId={ovrlMbsdsExpndDocId}
                            setModalOpen={setGrnamtModalOpen}
                        />
                    </Modal>

                    {/* ========================= 우정실무원 교부금 모달 ========================= */}
                    <Modal modalOpen={empGrnamtModalOpen} dim={true} visible={true}
                        titleEl={<DialogTitleBar title="우정 실무원 교부금 배정 관리" />}
                        onCloseFunc={() => setEmpGrnamtModalOpen(false)}
                    >
                        <BgtOvrlEmpGrnamtViewDialog
                        ovrlMbsdsExpndDocId={ovrlMbsdsExpndDocId}
                        setModalOpen={setEmpGrnamtModalOpen}
                        />
                    </Modal>

                    {/* 닫기 버튼 */}
                    <div className="dpFlx jcC pt20 pb20">
                        <Button buttonName="닫기"
                            width={110} height={42}
                            fontFamily="fm-b" fontSize={16} letterSpacing={-1}
                            variant="styCloseBtn" borderRadius={5}
                            buttonClass="dpFlx aiC jcC op80-hover"
                            onClickFunc={() => setOvrlExpndModalOpen(false)}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BgtOvrlExpndViewDialog;